import type { ReactNode } from 'react'
import { InformationCircleIcon } from '@heroicons/react/16/solid'

/** Background a step does not need at a glance, one click away. */
export const InfoDisclosure = ({
  label = 'How this works',
  testId,
  children
}: {
  label?: string
  testId?: string
  children: ReactNode
}) => (
  <details className="text-xs text-slate-600" data-testid={testId}>
    <summary className="inline-flex cursor-pointer list-none items-center gap-1 text-slate-500 hover:text-slate-800">
      <InformationCircleIcon className="h-3.5 w-3.5" /> {label}
    </summary>
    <div className="mt-1 space-y-1">{children}</div>
  </details>
)
